import { Emoji } from 'emoji-mart';
import { Remarkable } from 'remarkable';
import { linkify } from 'remarkable/linkify';

import { DEFAULT_REMARKABLE_OPTIONS } from './remarkable';
import { EMOJI_SIZE } from './emoji';
import { isValidEmoji } from './isValidEmoji';

async function loadKatex() {
  const katex = await import('./remarkableKatex');
  return katex.default;
}

function addEmojisPlugin(remarkable) {
  // Emoji parsing
  remarkable.inline.ruler.push('emoji', (state, checkMode) => {
    const { pos, posMax, src } = state;
    if (src.charAt(pos) === ':') {
      const closePos = src.indexOf(':', pos + 1);
      /* istanbul ignore else */
      if (closePos <= posMax) {
        const emojiId = src.substring(pos + 1, closePos);
        /* istanbul ignore else */
        if (isValidEmoji(emojiId)) {
          /* istanbul ignore else */
          if (!checkMode) {
            state.push({
              type: 'emoji',
              content: emojiId,
              block: false,
              level: state.level,
            });
          }
          state.pos = closePos + 1;
          return true;
        }
      }
    }
    return false;
  });

  remarkable.renderer.rules.emoji = function (tokens, index) {
    const token = tokens[index];
    return Emoji({
      html: true,
      native: true,
      emoji: token.content,
      size: EMOJI_SIZE,
    });
  };
}

function addLinksPlugin(remarkable) {
  remarkable.use(linkify);
}

async function addMathExpressionsPlugin(remarkable) {
  const katex = await loadKatex();
  remarkable.use(katex);
}

export default async function mdToHtml({
  mdString,
  options,
  parseEmojis,
  parseLinks,
  parseMathExpressions,
}) {
  const remarkable = new Remarkable();

  remarkable.set({
    ...DEFAULT_REMARKABLE_OPTIONS,
    ...options,
  });

  if (parseEmojis) {
    addEmojisPlugin(remarkable);
  }

  if (parseLinks) {
    addLinksPlugin(remarkable);
  }

  if (parseMathExpressions) {
    await addMathExpressionsPlugin(remarkable);
  }

  try {
    return remarkable.render(mdString);
  } catch (err) {
    return mdString;
  }
}
